<template>
  <!-- 风险指数 -->
  <div class="risk">
    <el-form :inline="true" :model="formData" class="demo-form-inline bginput" label-width="6rem">
      <el-form-item label="风险指数">
        <el-select v-model="set.getType" placeholder="请选择">
          <el-option label="手动录入" :value="0"></el-option>
          <el-option label="后台获取" :value="1"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <table class="mytable">
      <thead>
        <tr>
          <th style="width:10%;">月份</th>
          <th v-for="(mon,index) in 12" :key="index">{{index+1}}月</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style="background:#203bd5;text-align:center">风险指数</td>
          <td>
            <el-input oninput="if(value > 200) value=200" v-model="formData.oneData" placeholder="请输入0~200"></el-input>
          </td>
          <td>
            <el-input oninput="if(value > 200) value=200" v-model="formData.twoData" placeholder="请输入0~200"></el-input>
          </td>
          <td>
            <el-input oninput="if(value > 200) value=200" v-model="formData.threeData" placeholder="请输入0~200"></el-input>
          </td>
          <td>
            <el-input oninput="if(value > 200) value=200" v-model="formData.fourData" placeholder="请输入0~200"></el-input>
          </td>
          <td>
            <el-input oninput="if(value > 200) value=200" v-model="formData.fiveData" placeholder="请输入0~200"></el-input>
          </td>
          <td>
            <el-input oninput="if(value > 200) value=200" v-model="formData.sixData" placeholder="请输入0~200"></el-input>
          </td>
          <td>
            <el-input oninput="if(value > 200) value=200" v-model="formData.sevenData" placeholder="请输入0~200"></el-input>
          </td>
          <td>
            <el-input oninput="if(value > 200) value=200" v-model="formData.eightData" placeholder="请输入0~200"></el-input>
          </td>
          <td>
            <el-input oninput="if(value > 200) value=200" v-model="formData.nineData" placeholder="请输入0~200"></el-input>
          </td>
          <td>
            <el-input oninput="if(value > 200) value=200" v-model="formData.tenData" placeholder="请输入0~200"></el-input>
          </td>
          <td>
            <el-input oninput="if(value > 200) value=200" v-model="formData.elevenData" placeholder="请输入0~200"></el-input>
          </td>
          <td>
            <el-input oninput="if(value > 200) value=200" v-model="formData.twelveData" placeholder="请输入0~200"></el-input>
          </td>

        </tr>
      </tbody>
    </table>
    <div style="margin-top: 2rem;">
      <el-button @click="save" size="small" type="primary">保存设置</el-button>
    </div>

  </div>
</template>

<script>
import api from '@/apis/safety/risk'
export default {
  data() {
    return {
      //通用循环数据
      set:{
        getType: 0,
      },
      formData: {
        oneData: '',
        twoData: '',
        threeData: '',
        fourData: '',
        fiveData: '',
        sixData: '',
        sevenData: '',
        eightData: '',
        nineData: '',
        tenData: '',
        elevenData: '',
        twelveData: '',
      },
    }
  },
  mounted() {
    api
      .list({
        params: {
          limit: 100,
          page: 1,
        },
      })
      .then((res) => {
        if (res.code === 10000) {
          if (res.data.list.length) {
            this.formData = res.data.list[0]
          }
        } else {
          this.$message.error(res.message)
        }
      })
  },
  methods: {
    save() {
      for (const key in this.formData) {
        if (this.formData[key]=='') {
          this.formData[key]=0
        }
      }
      api.save(this.formData).then((res) => {
        if (res.code === 10000) {
          this.$message.success(res.message)
        } else {
          this.$message.error(res.message)
        }
      })
    },
  },
}
</script>

<style lang="less">
.risk { padding-top: 10px;
}
</style>